module.exports = __webpack_public_path__ + "dc91a9eff019250df0ca9a9509d32061.svg";